const TEST_DATA = {
  CurrentlyServicingBy: ['CSS', 'MPF'],

  Description: [
    '11111 11111 11111 11111 11111 11111 11111 11111',
    '22222 22222 22222 22222 22222 22222 22222 22222',
    '33333 33333 33333 33333 33333 33333 33333 33333',
    '44444 44444 44444 44444 44444 44444 44444 44444',
  ],

  EmailAddresses: [
    'testuser1@example.com',
    'john.doe1234@gmail.com',
    'alice.smith_567@yahoo.com',
    'jane_doe@outlook.com',
    'test.email@domain.net',
    'randomuser42@protonmail.com',
    'webmaster@company.org',
    'user12345@mywebsite.dev',
    'support@sampleapp.io',
    'marketing.team@example.org',
    'developer007@testing.dev',
    'contact_us@mycompany.com',
    'admin@myblog.net',
    'customer.service@ecommerce.biz',
    'feedback@productreviews.org',
    'info@randomstartup.com',
    'no-reply@newsletter.co',
    'testaccount@testing123.org',
    'demo.user@webapp.dev',
    'sandbox@playground.site',
  ],

  Installations: [
    'DUKE FIELD ABS FL',
    'EGLIN AFB FL',
  ],

  // To-do: replace with org metadata once available
  Organizations: [
    '20 SPACE CONTROL SQ 4',
    '33 FIGHTER WG',
    '33 MAINTENANCE SQ',
    '60 FIGHTER SQ',
  ],

  PersonNames: [
    'Angela Walsh',
    'Warren Parr',
    'Leonard Mathis',
    'Samantha North',
    'Austin Ball',
    'Colin Mackay',
    'Oliver Forsyth',
    'William Tucker',
    'Luke Baker',
    'Felicity Cornish',
    'Piers Gray',
    'Steven Fisher',
    'Stephanie Roberts',
    'Sonia Alsop',
    'Alexander Wright',
    'Joan Hill',
    'Alexandra Hunter',
    'Grace Mitchell',
    'Wendy Duncan',
    'Julia Wallace',
  ],

  Ranks: [
    '2d Lt',
    'A1C',
    'AB',
    'Amn',
    'Capt',
    'Civilian',
    'CMSgt',
    'Contractor',
  ],

  Subject: [
    'Unable to Access Email Account',
    'Password Reset Request',
    'Printer Connection Failure',
    'Software Installation Error',
    'VPN Connectivity Issues',
    'Hardware Upgrade Inquiry',
    'Data Recovery from Crashed System',
    'Mobile Device Synchronization Problem',
    'Wi-Fi Network Keeps Dropping',
    'Laptop Battery Not Charging',
    'Desktop Monitor Flickering',
    'Email Attachment Not Opening',
    'VoIP Call Quality Poor',
    'New Employee IT Setup Required',
    'System Performance is Slow',
    'Application License Renewal',
    'Security Patch Update Failure',
    'Remote Access Permission Needed',
    'Outlook Calendar Sync Error',
    'Antivirus Software Alert Message',
  ],
}

export default TEST_DATA
